import { useContext, useEffect } from 'react';
import {
    Button,
    Form,
    Input,
    Modal,
    Select,
    Space,
    Typography,
} from 'antd';
import { WorkspaceModuleContext } from '../context/module.context';
import { IModuleConfig } from '../context/context.interface';

interface Props {
    open: boolean;
    workspaceId: string;
    onClose: () => void;
}

const { Text } = Typography;

const CreateModule = ({ open, onClose, workspaceId }: Props) => {
    const {
        loadingAction,
        createItem,
        moduleConfigs,
        fetchModuleConfigs,
    } = useContext(WorkspaceModuleContext);

    const [form] = Form.useForm();

    const MODULES = moduleConfigs
        .map(({ keyName, name }: IModuleConfig) => ({
            label: name,
            value: keyName,
        }));

    useEffect(() => {
        fetchModuleConfigs();
    }, []);

    return (
        <Modal
            title="Create Module"
            open={open}
            onCancel={onClose}
            footer={null}
        >
            <Space direction="vertical" size={24} style={{ width: '100%' }}>
                <Text>
                    Select the module you want to create.
                </Text>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={() => {
                        createItem(form.getFieldsValue());
                        form.resetFields();
                        onClose();
                    }}
                    initialValues={{
                        workspaceID: workspaceId,
                    }}
                >
                    <Form.Item name="moduleKeyName" label="Module">
                        <Select options={MODULES} disabled={loadingAction} />
                    </Form.Item>
                    <Form.Item name="workspaceID" label="Workspace" hidden>
                        <Input />
                    </Form.Item>
                    <Button
                        block
                        type="primary"
                        htmlType="submit"
                        loading={loadingAction}
                    >
                        Create
                    </Button>
                </Form>

            </Space>
        </Modal>
    );
};

export default CreateModule;
